import { Observable } from 'rxjs';
import { AuthInterceptorBase } from './auth-interceptor-base';

export class AuthInterceptor extends AuthInterceptorBase {
  override setTimeZoneOffset(): void {
    this._timeZoneOffset = new Date().getTimezoneOffset() * -1;
  }

  override setTokenHeader(token: string): {
    headerKey: string;
    headerValue: string;
  } {
    return {
      headerKey: 'Authorization',
      headerValue: `Bearer ${token}`,
    };
  }

  override setAdditionalHeaders(): Array<{
    headerKey: string;
    headerValue: string;
  }> {
    return [];
  }

  override getAccessToken(): Observable<string> {
    return this.authService.getAccessToken();
  }
}
